import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";

import course04 from "../../../course/course-04/course";
import lesson0402 from "../../../lesson/course-04/lesson-02/lesson";
import lesson0403 from "../../../lesson/course-04/lesson-03/lesson";
import lesson0404 from "../../../lesson/course-04/lesson-04/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "7157ae18-7bb3-47fc-9e90-30839c45e2b6",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0402),
    lesson: lesson0402,
  },
  {
    id: "23568a16-6b26-4b9a-8b28-f2773fe6c350",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0403),
    lesson: lesson0403,
  },
  {
    id: "ca49516e-f908-422c-aa9e-0b99aacb5196",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0404),
    lesson: lesson0404,
  },
];

export default lessonLinks;
